



























































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { DecorationType, QuestionType } from "@/modules/newCommunity/pages/operationTools/config/questionnaire";
import { convertData, getRandomForm } from "@/modules/newCommunity/pages/operationTools/pages/questionnaireEdit/config/manualAddNew";

// import { activeManageModule } from "@/modules/newCommunity/pages/activeCenter/activeManage/store/index";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";

import singleChoice from "../previewSetting/singleChoice.vue";
import multipleChoice from "../previewSetting/multipleChoice.vue";
import fillIn from "../previewSetting/fillIn.vue";
import phoneNumber from "../previewSetting/phoneNumber.vue";
import cascade from "../previewSetting/cascade.vue";
import uploadAddon from "../previewSetting/uploadAddon.vue";
import imageSetting from "../previewSetting/imageSetting.vue";
import textSetting from "../previewSetting/textSetting.vue";
import empty from "@/modules/community/pages/components/empty.vue";
import { ElForm } from "element-ui/types/form";
import { randomNumber } from "@/utils/commonUtil";

import { getCatalog, baseQuestionnaireGetPage, getRandomItems, getCatalogSummary, getAllIds, EnumBusinessType, EnumCommunityType } from "@modules/newCommunity/pages/operationTools/api/questionnaire";
import { service } from "@modules/newCommunity/setup";

@Component({
  name: "manualAddComponent",
  components: {
    singleChoice,
    multipleChoice,
    fillIn,
    phoneNumber,
    cascade,
    uploadAddon,
    imageSetting,
    textSetting,
    empty,
  },
  filters: {},
})
export default class extends Vue {
  @Prop({ type: Boolean }) value!: Boolean;
  @Prop({ type: String }) type!: String;

  get sourceList() {
    return QuestionnaireEditModule.dataList;
  }

  get questionLen() {
    return this.checkedCities.length || 0;
  }

  get selectedQuestionList() {
    return this.dataList.filter((item: any) => {
      return this.checkedCities.includes(item.data.qbid);
    });
  }

  get questionnaireType(): EnumBusinessType {
    // 判断 问卷 答题
    return QuestionnaireEditModule.questionnaireType as EnumBusinessType;
  }
  get questionnaireProperty() {
    // 判断 问卷 答题
    return QuestionnaireEditModule.questionnaireProperty;
  }

  get communityType(): EnumCommunityType {
    return this.$route.path.includes("newCommunity") ? EnumCommunityType.DOCTOR : EnumCommunityType.PATIENT;
  }

  get addQuestionRouterName() {
    return this.communityType === EnumCommunityType.DOCTOR ? "newCom_operationTools_addQuestion" : "newCom_operationTools_addQuestion";
  }

  get activeCatalogIndexId(): number | null {
    console.log(this.catalogList, this.activeCatalogIndex);

    return this.catalogList[this.activeCatalogIndex].id;
  }

  get basicParams() {
    return {
      businessType: this.questionnaireType,
      communityType: this.communityType,
      businessTypeProperty: this.questionnaireProperty,
      questionnaireProperty: this.questionnaireProperty,
    };
  }

  @Watch("value")
  async watchValue() {
    if (this.value) {
      // TODO: 如果外层删除了组件需要更新数据
      this.checkedCities = (this.sourceList as any).filter((item: any) => item.fromQuestionBank || item.data.fromQuestionBank).map((iten: any) => iten.data.qbid);
      this.checkSelectedQuestion = false;
      this.activeIndex = 1;
      this.activeCatalogIndex = 0;

      this.catalogList = [];
      this.catalogListPageNum = 1;
      this.searchQuestion = "";
      this.getCatalogServe();
      this.randomForm = getRandomForm();

      if (this.checkedCities.length > 0) {
        this.allLoading = true;
        const data = await getAllIds({ ...this.basicParams });
        this.allQuestionLen = data.length;
        this.checkedCities = this.checkedCities.filter((item: any) => data.includes(item));
        this.allLoading = false;
      }
    }
  }

  @Watch("questionnaireType")
  watchQuestionnaireType() {
    this.handleSearchCatalog();
    this.getClassifyList();
  }

  mounted() {
    this.handleSearchCatalog();
    // this.getClassifyList();
  }

  public EnumBusinessType = EnumBusinessType;

  private activeIndex = 1;
  private dataListPageNum = 1;
  private maxDataListPageNum = 1;
  private checkAll = false;
  private isIndeterminate = true;
  private checkSelectedQuestion = false;
  private selectSearchLoging = false;
  private allLoading = false;
  private allQuestionNums = 0;
  private allQuestionLen = 0;

  private activeCatalogIndex = 0;
  private catalogList: any[] = []; // 分类列表
  private catalogLoading = false;
  private catalogValue = "";
  private catalogListPageNum = 1;
  private maxCatalogListPagenum = 1;

  private classifyList = [];
  private remoteLoading = false;

  private selectedQuestionValue = ""; // 已选题目搜索字段
  private selectedList: any[] = []; // 已选题目搜索列表
  private checkedCities: any[] = [];
  private stagScoreList: any = new Map();

  private randomForm: any = getRandomForm();
  private randomFormRules = {
    randomSet: [{ required: true, message: "请设置随机范围" }],
    randomRange: [{ required: true, message: "请设置随机范围" }],
    num: [
      { required: true, message: "请输入题目数量" },
      {
        validator: this.validator1,
        trigger: "blur",
      },
      {
        pattern: /(^[1-9][0-9]{0,5}$)/,
        message: "请输入1~999999范围内的整数",
        trigger: "blur",
      },
    ],
    selectClassification: [{ required: true, message: "请选择分类" }],
    randomProps: [
      { required: true, message: "请设置题数", trigger: "change" },
      {
        validator: (rule: any, value: any, callback: any) => {
          value.forEach((item: any) => {
            if (!item.num || item.num > item.relationNum || !/(^[1-9][0-9]{0,5}$)/.test(item.num)) {
              callback(new Error("请填写不大于分类总题数的随机抽取的题数"));
              return;
            }
          });
          callback();
        },
        trigger: "change",
      },
    ],
  };
  private randomIds: any[] = [];

  private dataList: any = [];
  private dataListLoading = false;
  private searchQuestion = "";
  private deterMineLoading = false;

  private componentName(item: any) {
    if (item) {
      switch (item.componentName + "") {
        case QuestionType.singleChoice:
          return "singleChoice";
        case QuestionType.multipleChoice:
          return "multipleChoice";
        case QuestionType.phoneNumber:
          return "phoneNumber";
        case QuestionType.fillIn:
          return "fillIn";
        case QuestionType.cascade:
          return "cascade";
        case QuestionType.uploadAddon:
          return "uploadAddon";
        case DecorationType.picture:
          return "imageSetting";
        case DecorationType.text:
          return "textSetting";
      }
    }
    return "";
  }

  private componentNameTitle(item: any) {
    if (item) {
      switch (item.componentName + "") {
        case QuestionType.singleChoice:
          return "(单选)";
        case QuestionType.multipleChoice:
          return "";
        case QuestionType.phoneNumber:
          return "";
        case QuestionType.fillIn:
          return "(填空)";
        case QuestionType.cascade:
          return "cascade";
        case QuestionType.uploadAddon:
          return "(上传附件)";
        case DecorationType.picture:
          return "";
        case DecorationType.text:
          return "";
      }
    }
    return "";
  }

  private validator1(rule: any, value: any, callback: any) {
    const allLen = this.allQuestionNums - this.checkedCities.length;
    if (value > allLen) {
      callback(new Error("随机抽取的题数不能大于该分类下的总题数"));
      return;
    }
    callback();
  }

  private dataListload() {
    if (this.dataListPageNum > this.maxDataListPageNum) return;
    this.getBaseQuestionnaireGetPageServe();
  }

  private catalogLoad() {
    if (this.catalogListPageNum > this.maxCatalogListPagenum) return;
    this.getCatalogServe();
  }

  private handleCheckAllChange(val: any) {
    if (this.dataList.length > 100) {
      this.$message.warning("最多只能选择100道题哦~");
      this.checkAll = false;
      return;
    }
    let ids = this.dataList.map((item: any) => item.data.qbid);
    if (val) {
      ids = [...ids, ...this.checkedCities];
    } else {
      ids = this.checkedCities.filter((item: any) => !ids.includes(item));
    }
    const set = new Set(ids);
    ids = Array.from(set);
    this.checkedCities = ids;
    this.isIndeterminate = false;
  }

  private validator(rule: any, value: any, callback: any) {
    if (rule.field) {
      const index = rule.field.split(".")[1];
      const excludeIds = (this.sourceList as any).filter((item: any) => item.data.qbid).map((iten: any) => iten.data.qbid);
      const ids = [...excludeIds, ...this.checkedCities];
      const relationNum = this.randomForm.randomProps[index].relationNum;
      const name = this.randomForm.randomProps[index].name;
      const itemIds = this.randomForm.randomProps[index].relationList && this.randomForm.randomProps[index].relationList.map((item: any) => item.itemId);
      let sameIds = ids.filter((item: any) => itemIds.includes(item));
      const arr = new Set(sameIds);
      sameIds = Array.from(arr);
      const maxLens = relationNum - sameIds.length;
      if (value > maxLens) {
        if (this.activeIndex !== 2) {
          this.onTab(2);
        }
        setTimeout(() => {
          this.$message.error(`${name}下的可用题目数为${maxLens}，请重新设置随机题目数值`);
        }, 0);
        callback(new Error(" "));
      } else {
        callback();
      }
    } else {
      callback();
    }
  }

  private handleCheckedCitiesChange(value: any[]) {
    let checkedCount = this.dataList.filter((item: any) => value.includes(item.data.qbid)).length;
    this.checkAll = checkedCount === this.dataList.length;
    this.isIndeterminate = checkedCount > 0 && checkedCount < this.dataList.length;
  }

  private handleSearch() {
    this.resetDataList();
  }

  private handleSearchCatalog() {
    this.activeCatalogIndex = 0;
    this.catalogList = [];
    this.catalogListPageNum = 1;
    this.getCatalogServe();
  }

  private handleCatalog(item: any, index: number) {
    this.activeCatalogIndex = index;
    this.resetDataList();
  }

  private async handleSearchSelected() {
    this.selectSearchLoging = true;
    const params = {
      ...this.basicParams,
      includeIds: this.checkedCities,
      question: this.selectedQuestionValue,
      pageSize: 1000,
      pageNum: 1,
    };
    // let { rows: data } = await baseQuestionnaireGetPage(params);
    let res = await service.questionBankGetPageInfo(params);
    let data = res.data.rows;

    data.forEach((item: any) => {
      item.qbid = item.id;
      item.id = "";
    });
    data = convertData(data);
    // data.forEach((item: any) => {
    //   if (this.stagScoreList.has(item.data.qbid)) item.data.itemScore = this.stagScoreList.get(item.data.qbid);
    // });
    let list: any[] = [];
    this.checkedCities.forEach((item: any) => {
      data.forEach((iten: any) => {
        if (item === iten.data.qbid) {
          list.push(iten);
        }
      });
    });
    this.selectedList = list || [];
    this.selectSearchLoging = false;
  }

  private onVisibleSelectQuestion() {
    this.handleSearchSelected();
    this.checkSelectedQuestion = true;
  }

  private onKeepSelect() {
    // TODO: 保存题目分值
    // this.selectedList.forEach((item: any) => {
    //   this.stagScoreList.set(item.data.qbid, item.data.itemScore);
    // });
    const checkIds = this.dataList.filter((item: any) => this.checkedCities.includes(item.data.qbid));
    this.selectedQuestionValue = "";
    this.checkAll = this.dataList.length === checkIds.length;
    this.isIndeterminate = checkIds.length > 0 && checkIds.length < this.dataList.length;
    this.checkSelectedQuestion = false;
  }

  private toAddQuestion() {
    // let routeUrl = this.$router.resolve({
    //   name: this.addQuestionRouterName,
    //   query: { model: "add" },
    // });
    let routeUrl = this.$router.resolve({
      name: "newCom_newActiveTools_questionBankManage_addQuestion",
      query: { model: "add" },
    });
    window.open(routeUrl.href, "_blank");
  }

  onTab(index: number) {
    if (this.activeIndex === 2 && index === 1 && this.randomForm.randomSet) {
      (this.$refs.ruleRandomForm as ElForm).validate((valid: boolean) => {
        if (valid) this.activeIndex = index;
      });
    } else {
      this.activeIndex = index;
    }
  }

  handleClose() {
    this.$emit("input", false);
  }

  private handleClassify(item: any) {
    const index = this.randomForm.randomProps.findIndex((iten: any) => iten.id === item.id);
    // item.num = undefined;
    item.catalogId = item.id;
    if (index === -1) {
      this.randomForm.randomProps.push(item);
    } else {
      this.randomForm.randomProps.splice(index, 1);
    }
    console.warn("randomProps", this.randomForm.randomProps);
  }

  private randomRangeChange() {
    this.randomForm.num = null;
    this.randomForm.selectClassification = [];
    this.randomForm.randomProps = [];
    (this.$refs.ruleRandomForm as ElForm).clearValidate();
  }

  private resetDataList() {
    this.dataListPageNum = 1;
    this.maxDataListPageNum = 1;
    this.dataList = [];
    this.getBaseQuestionnaireGetPageServe();
  }

  private focusClassifyList() {
    this.getClassifyList();
  }

  removeTag(tag: any) {
    const index = this.randomForm.randomProps.findIndex((item: any) => item.id == tag);
    this.randomForm.randomProps.splice(index, 1);
    const delIdIndex = this.randomForm.selectClassification.findIndex((item: any) => item == tag);

    if (delIdIndex !== -1) {
      this.randomForm.selectClassification.splice(delIdIndex, 1);
    }
  }

  getClassifyList(name?: string) {
    this.remoteLoading = true;
    getCatalog({ ...this.basicParams, name, pageSize: 50, pageNum: 1 })
      .then((res: any) => {
        this.classifyList = res.rows || [];
      })
      .finally(() => (this.remoteLoading = false));
  }

  getCatalogServe() {
    if (this.catalogLoading) return;
    this.catalogLoading = true;
    getCatalogSummary({
      ...this.basicParams,
      name: this.catalogValue,
      pageNum: this.catalogListPageNum,
      pageSize: 20,
    })
      .then((res: any) => {
        this.catalogList = [...this.catalogList, ...res.rows] ?? [];
        if (res.rows.length && res.rows[0].name == "全部题目") {
          this.allQuestionNums = res.rows[0].count;
        }
        if (this.catalogList.length !== 0 && this.catalogListPageNum == 1) {
          this.resetDataList();
        } else if (this.catalogList.length == 0 && this.catalogListPageNum == 1) {
          this.dataList = [];
        }
        this.maxCatalogListPagenum = res.totalPage;
        this.catalogListPageNum++;
      })
      .finally(() => (this.catalogLoading = false));
  }

  getBaseQuestionnaireGetPageServe() {
    if (this.dataListLoading) return;
    this.dataListLoading = true;
    // baseQuestionnaireGetPage({
    //   ...this.basicParams,
    //   catalogId: this.activeCatalogIndexId,
    //   question: this.searchQuestion,
    //   pageSize: 20,
    //   pageNum: this.dataListPageNum,
    // })
    // .then((res: any) => {
    //     let itemList = res.rows;
    //     itemList.forEach((item: any) => {
    //       item.qbid = item.id;
    //       item.id = "";
    //     });
    //     const data = convertData(itemList);
    //     this.dataList = [...this.dataList, ...data];
    //     this.maxDataListPageNum = res.totalPage;
    //     const checkIds = this.dataList.filter((item: any) => this.checkedCities.includes(item.data.qbid));
    //     this.checkAll = this.dataList.length === checkIds.length;
    //     this.isIndeterminate = checkIds.length > 0 && checkIds.length < this.dataList.length;
    //     this.dataListPageNum++;
    //   })
    //   .finally(() => (this.dataListLoading = false));
    service
      .questionBankGetPageInfo({
        ...this.basicParams,
        // catalogId: this.activeCatalogIndexId,
        catalogIds: this.activeCatalogIndexId ? [this.activeCatalogIndexId] : [],
        question: this.searchQuestion,
        pageSize: 20,
        pageNum: this.dataListPageNum,
      })
      .then((res: any) => {
        let itemList = res.data.rows;
        itemList.forEach((item: any) => {
          item.qbid = item.id;
          item.id = "";
        });
        const data = convertData(itemList);
        this.dataList = [...this.dataList, ...data];
        this.maxDataListPageNum = res.data.totalPage;
        const checkIds = this.dataList.filter((item: any) => this.checkedCities.includes(item.data.qbid));
        this.checkAll = this.dataList.length === checkIds.length;
        this.isIndeterminate = checkIds.length > 0 && checkIds.length < this.dataList.length;
        this.dataListPageNum++;
      })
      .finally(() => (this.dataListLoading = false));
  }

  private async handleDetermine() {
    // if (this.checkSelectedQuestion) {
    //   // 当他在已选题目状态的时候 要收集题目分数值
    //   this.selectedList.forEach((item: any) => {
    //     this.stagScoreList.set(item.data.qbid, item.data.itemScore);
    //   });
    // }
    let ids: any[] = this.checkedCities;
    let randomData: any = [];
    if (this.randomForm.randomSet && this.randomForm.randomRange == "all" && this.randomForm.num > this.allQuestionNums) {
      this.$message.error("题目数量不能超过题目总数");
      return;
    }
    if (this.randomForm.randomSet) {
      const valid = await (this.$refs.ruleRandomForm as ElForm).validate();
      if (!valid) return;

      const excludeIds = (this.sourceList as any).filter((item: any) => item.data.qbid).map((iten: any) => iten.data.qbid);
      const param: any = {
        ...this.basicParams,
        excludeIds: [...excludeIds, ...this.checkedCities],
        randomProps: null,
        pageSize: 1000,
        pageNum: 1,
      };
      if (this.randomForm.randomRange === "all") {
        param.num = this.randomForm.num;
        const allLen = this.checkedCities.length + Number(this.randomForm.num);
        if (allLen > 100) {
          this.$message.error("最多只能选择100道题目哦~");
          return;
        }
      }
      if (this.randomForm.randomRange === "appoint") {
        param.randomProps = this.randomForm.randomProps;
        const arrLen = this.randomForm.randomProps.reduce((a: any, b: any) => {
          return a + Number(b.num);
        }, 0);
        const allLen = this.checkedCities.length;
        if (arrLen + allLen > 100) {
          this.$message.error("最多只能选择100道题目哦~");
          return;
        }
      }
      randomData = await getRandomItems(param);

      this.randomIds = [...this.randomIds, ...randomData];
      this.checkedCities = [...this.checkedCities, ...randomData];
      ids = [...ids, ...randomData];
    }
    if (!this.checkedCities.length && !ids.length) {
      const sourceList = (this.sourceList as any).filter((item: any) => !item.fromQuestionBank);

      QuestionnaireEditModule.SET_DATA_LIST(sourceList);
      QuestionnaireEditModule.SET_INDEX_COMPONENTS(sourceList.length - 1);

      this.handleClose();
      return;
    }
    this.deterMineLoading = true;
    const params = {
      ...this.basicParams,
      includeIds: ids,
      pageSize: 1000,
      pageNum: 1,
    };
    // let { rows: data } = await baseQuestionnaireGetPage(params);
    let res = await service.questionBankGetPageInfo(params);
    let data = res.data.rows;

    data.forEach((item: any) => {
      item.qbid = item.id;
      item.id = "";
    });
    data = convertData(data);
    const sourceList = (this.sourceList as any).filter((item: any) => !item.fromQuestionBank && !item.data.fromQuestionBank);
    const map = new Map();
    const listData = data.filter((item: any) => !map.has(item.data.qbid) && map.set(item.data.qbid, 1));
    let sortArr: any[] = [];

    this.checkedCities.forEach((item: any) => {
      listData.forEach((iten: any) => {
        if (item === iten.data.qbid) {
          sortArr.push(iten);
        }
      });
    });
    console.warn("sortArr", sortArr);
    console.warn("sourceList", sourceList);
    const result = [...sourceList, ...sortArr];
    result.forEach((item: any) => {
      // 填充分值
      // if (this.stagScoreList.has(item.data.qbid)) {
      //   item.data.itemScore = this.stagScoreList.get(item.data.qbid);
      // }
      if (!item.data.id) {
        item.data.id = Number("1" + (randomNumber(6) + "")) * -1;
      }

      if (item.data.optionsList && item.data.optionsList.length > 0) {
        item.data.optionsList.forEach((oitem: any) => {
          if (!oitem.id) {
            oitem.id = Number("1" + (randomNumber(6) + "")) * -1;
          }
        });
      }
      // 随机的题目 不开启加入题库
      // if (randomData.includes(item.data.id)) delete item.fromQuestionBank;
    });

    QuestionnaireEditModule.SET_DATA_LIST(result);
    QuestionnaireEditModule.SET_INDEX_COMPONENTS(result.length - 1);

    console.warn("result", result);
    this.deterMineLoading = false;
    this.handleClose();
  }
}
